export const APPROVED_PRODUCTS_REQUEST = "APPROVED_PRODUCTS_REQUEST";
export const APPROVED_PRODUCTS_SUCCESS = "APPROVED_PRODUCTS_SUCCESS";
export const APPROVED_PRODUCTS_FAIL = "APPROVED_PRODUCTS_FAIL";

export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL";

export const PRODUCT_CREATE_REVIEW_REQUEST = 'PRODUCT_CREATE_REVIEW_REQUEST'
export const PRODUCT_CREATE_REVIEW_SUCCESS = 'PRODUCT_CREATE_REVIEW_SUCCESS'
export const PRODUCT_CREATE_REVIEW_FAIL = 'PRODUCT_CREATE_REVIEW_FAIL'
export const PRODUCT_CREATE_REVIEW_RESET = 'PRODUCT_CREATE_REVIEW_RESET'

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST'
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS'
export const PRODUCT_CREATE_FAIL = 'PRODUCT_CREATE_FAIL'
export const PRODUCT_CREATE_RESET = 'PRODUCT_CREATE_RESET'


export const PRODUCT_APPROVED_REQUEST = "PRODUCT_APPROVED_REQUEST";
export const PRODUCT_APPROVED_SUCCESS = "PRODUCT_APPROVED_SUCCESS";
export const PRODUCT_APPROVED_FAIL = "PRODUCT_APPROVED_FAIL";

export const ARTISAN_PRODUCTS_REQUEST = "ARTISAN_PRODUCTS_REQUEST";
export const ARTISAN_PRODUCTS_SUCCESS = "ARTISAN_PRODUCTS_SUCCESS";
export const ARTISAN_PRODUCTS_FAIL = "ARTISAN_PRODUCTS_FAIL";


export const ARTISAN_PRODUCTS_DETAIL_REQUEST = "ARTISAN_PRODUCTS_DETAIL_REQUEST";
export const ARTISAN_PRODUCTS_DETAIL_SUCCESS = "ARTISAN_PRODUCTS_DETAIL_SUCCESS";
export const ARTISAN_PRODUCTS_DETAIL_FAIL = "ARTISAN_PRODUCTS_DETAIL_FAIL";


export const ARTISAN_PRODUCT_APPROVED_REQUEST = "ARTISAN_PRODUCT_APPROVED_REQUEST";
export const ARTISAN_PRODUCT_APPROVED_SUCCESS = "ARTISAN_PRODUCT_APPROVED_SUCCESS";
export const ARTISAN_PRODUCT_APPROVED_FAIL = "ARTISAN_PRODUCT_APPROVED_FAIL";





export const PRODUCT_FILTER_REQUEST = "PRODUCT_FILTER_REQUEST";
export const PRODUCT_FILTER_SUCCESS = "PRODUCT_FILTER_SUCCESS";
export const PRODUCT_FILTER_FAIL = "PRODUCT_FILTER_FAIL";


